const ELK_ENDPOINT = process.env.ELK_ENDPOINT ?? "";
const ELK_USERNAME = process.env.ELK_USERNAME ?? "";
const ELK_PASSWORD = process.env.ELK_PASSWORD ?? "";

type LogLevelType =
  | "FATAL"
  | "ERROR"
  | "WARN"
  | "INFO"
  | "DEBUG"
  | "TRACE"
  | "UTM";
export const ElkedLog = async (
  message: string,
  level: LogLevelType = "INFO"
) => {
  if (!(!!ELK_PASSWORD && !!ELK_USERNAME && !!ELK_ENDPOINT)) return null;
  try {
    await fetch(ELK_ENDPOINT ?? "", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          Buffer.from(`${ELK_USERNAME ?? ""}:${ELK_PASSWORD ?? ""}`).toString(
            "base64"
          ),
      },
      body: JSON.stringify({
        message,
        level,
      }),
    });
  } catch (error) {
    console.error("Failed to send log: \n", error);
  }
};

export const ElkedUTMLog = async (record: Record<string, string>) => {
  if (!(!!ELK_PASSWORD && !!ELK_USERNAME && !!ELK_ENDPOINT)) return null;
  try {
    await fetch(ELK_ENDPOINT ?? "", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          Buffer.from(`${ELK_USERNAME ?? ""}:${ELK_PASSWORD ?? ""}`).toString(
            "base64"
          ),
      },
      body: JSON.stringify({
        ...record,
        level: "UTM",
      }),
    });
  } catch (error) {
    console.error("Failed to send log: \n", error);
  }
};
